import { Plugin } from "ckeditor5";

export default class SelectivePaste extends Plugin {
  static get pluginName() {
    return "SelectivePaste";
  }

  init() {
    const editor = this.editor;

    editor.editing.view.document.on("clipboardInput", (evt, data) => {
      const dataTransfer = data.dataTransfer;
      const htmlContent = dataTransfer.getData("text/html");

      if (!htmlContent) {
        return;
      }

      const cleanedContent = this.cleanHtml(htmlContent);

      const viewFragment = editor.data.processor.toView(cleanedContent);

      data.content = viewFragment;
    });
  }

  cleanHtml(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const body = doc.body;

    const allowedAttributes = ["href", "src", "alt", "rowspan", "colspan"];

    const cleanElement = (element) => {
      const attributes = Array.from(element.attributes);
      attributes.forEach((attr) => {
        if (!allowedAttributes.includes(attr.name)) {
          element.removeAttribute(attr.name);
        }
      });

      Array.from(element.children).forEach((child) => cleanElement(child));
    };

    cleanElement(body);

    return body.innerHTML;
  }
}
